export default {
    voucher(data) {
        return axios.post("/api/ecommerce/voucher/validate", data);
    },
};
